import {
    i18n
} from '@/main.js'

export default {
    getRandomItem() {
        let selections = [
            ["gov", 4],
            ["traffic", 5],
            ["edu", 2],
            ["health", 4],
            ["env", 3],
            ["security", 2],
            ["architecture", 4],
            ["eco", 5]
        ];

        let sights = [
            "songyan",
            "beimen",
            "honglou",
            "longshan",
            "moma",
            "101",
            "dadaocheng"
        ];

        let rdnCat = selections[Math.floor(Math.random() * selections.length)];
        let rdnIdx = Math.ceil(Math.random() * rdnCat[1]);

        let sight = sights[Math.floor(Math.random() * sights.length)];
        console.log(rdnCat[0], rdnIdx);

        let recommendation = {
            scene: rdnCat[0],
            title: i18n.t(
                `home.scenes.${rdnCat[0]}.items.${rdnCat[0] + "_" + rdnIdx}`
            ).title_main,
            item_id: rdnIdx,
            sight: sight,
            sight_name: i18n.t(`explore.sights.${sight}.name`)
        };
        return recommendation
    },
    getReply(questionNo, ans) {
        let text = `回覆`
        switch(questionNo){
            case 1 :
                text = ans == '學生'? '哇 原來你是學生': '哇 辛苦了！'
                break;
            case 2 :
                text = '很不錯的安排！ 但偶而到戶外走走，也是不錯的選擇喔！'
                break;
            case 3:
                text = '等等是吃飯時間，要吃了什麼好呢? 給我些建議吧！'
                break;
            case 4:
                text = ['太好了！我也正想吃這個', '我也覺得很讚'][Math.round(Math.random())]
                break;
            case 5:
                text = '吃飽了！有力氣分析數據了…'
                break;
            default:
                break;
        }


        console.log(questionNo, ans)
        return {
            type: "text",
            author: `bot`,
            data: {
                text: text
            }
        }
    },
    calRecommendation(ans) {
        if (!ans) return this.getRandomItem()

        let possibleItems = []
        let possibleSights = []

        let checkTerm = (source, target) => {
            console.log(source, target)
            return source.includes(target)
        }

        // ans1
        switch (true) {
            case checkTerm(ans.ans1, '學生'):
                console.log('student')
                // possibleItems.push(i18n.t(`home.scenes.edu.items.edu_1`))
                // possibleItems.push(i18n.t(`home.scenes.edu.items.edu_2`))
                possibleItems.concat([
                    ['edu_1', i18n.t(`home.scenes.edu.items.edu_1`)],
                    ['edu_2', i18n.t(`home.scenes.edu.items.edu_2`)]
                ])
                break;
            case checkTerm(ans.ans1, '軍公教'):
                possibleItems.push(['security_1', i18n.t(`home.scenes.security.items.security_1`)])
                possibleItems.push(['security_2', i18n.t(`home.scenes.security.items.security_2`)])
                break;
            case checkTerm(ans.ans1, '科技業'):
                possibleItems.push(['traffic_2', i18n.t(`home.scenes.traffic.items.traffic_2`)])
                break;
            case checkTerm(ans.ans1, '農業'):
                possibleItems.push(['env_3', i18n.t(`home.scenes.env.items.env_3`)])
                break;
            case checkTerm(ans.ans1, '服務業'):
                possibleItems.push(['eco_3', i18n.t(`home.scenes.eco.items.eco_3`)])
                break;
            default:
                console.log('do nothing')
        }

        // ans2
        switch (true) {
            case checkTerm(ans.ans2, '宅在家'):
                possibleItems.push(['architecture_1', i18n.t(`home.scenes.architecture.items.architecture_1`)])
                break;
            case checkTerm(ans.ans2, '購物'):
                possibleItems.push(['eco_1', i18n.t(`home.scenes.eco.items.eco_1`)])
                possibleItems.push(['security_1', i18n.t(`home.scenes.security.items.security_1`)])
                possibleItems.push(['security_2', i18n.t(`home.scenes.security.items.security_2`)])
                break;
            case checkTerm(ans.ans2, '運動中心'):
                possibleItems.push(['gov_3', i18n.t(`home.scenes.gov.items.gov_3`)])
                possibleItems.push(['health_1', i18n.t(`home.scenes.health.items.health_1`)])
                break;
            case checkTerm(ans.ans2, '咖啡廳'):
                possibleItems.push(['eco_3', i18n.t(`home.scenes.eco.items.eco_3`)])
                // possibleItems.push(['traffic_1', i18n.t(`home.scenes.traffic.items.traffic_1`)])
                break;
                // case checkTerm(ans.ans2, '夜店'):
                //     possibleItems.push(['security_2', i18n.t(`home.scenes.security.items.security_2`)])
                //     break;
            case checkTerm(ans.ans2, '藝術展'):
                possibleSights.push(['songyan', i18n.t(`explore.sights.songyan`)])
                // possibleItems.push(['gov_3', i18n.t(`home.scenes.gov.items.gov_3`)])
                break;
            default:
                console.log('do nothing')
        }

        // ans3
        switch (true) {
            case checkTerm(ans.ans3, '自行車'):
                possibleItems.push(['traffic_3', i18n.t(`home.scenes.traffic.items.traffic_3`)])
                break;
            case checkTerm(ans.ans3, '公車'):
                possibleItems.push(['eco_2', i18n.t(`home.scenes.eco.items.eco_2`)])
                possibleItems.push(['traffic_2', i18n.t(`home.scenes.traffic.items.traffic_2`)])
                break;
            case checkTerm(ans.ans3, '摩托車'):
                possibleItems.push(['traffic_1', i18n.t(`home.scenes.traffic.items.traffic_1`)])
                possibleItems.push(['traffic_4', i18n.t(`home.scenes.traffic.items.traffic_4`)])
                break;
            case checkTerm(ans.ans3, '計程車') || checkTerm(ans.ans3, '開車'):
                possibleItems.push(['traffic_5', i18n.t(`home.scenes.traffic.items.traffic_5`)])
                break;
            default:
                console.log('do nothing')
        }

        // ans4
        switch (true) {
            case checkTerm(ans.ans4, '大腸麵線') || checkTerm(ans.ans4, '滷味'):
                possibleSights.push(['honglou', i18n.t(`explore.sights.honglou`)])
                break;
            case checkTerm(ans.ans4, '豬腳') || checkTerm(ans.ans4, '滷肉飯'):
                possibleSights.push(['dadaocheng', i18n.t(`explore.sights.dadaocheng`)])
                break;
            case checkTerm(ans.ans4, '牛排') || checkTerm(ans.ans4, '小籠包'):
                possibleSights.push(['101', i18n.t(`explore.sights.101`)])
                break;
            default:
                console.log('do nothing')
        }

        // ans5
        switch (true) {
            case checkTerm(ans.ans5, '抹茶蛋糕'):
                possibleSights.push(['songyan', i18n.t(`explore.sights.songyan`)])
                break;
            case checkTerm(ans.ans5, '豆花'):
                possibleSights.push(['longshan', i18n.t(`explore.sights.longshan`)])
                break;
            case checkTerm(ans.ans5, '冰淇淋總匯'):
                possibleSights.push(['moma', i18n.t(`explore.sights.moma`)])
                break;
            case checkTerm(ans.ans5, '檸檬派'):
                possibleSights.push(['beimen', i18n.t(`explore.sights.beimen`)])
                break;
            default:
                console.log('do nothing')
        }

        if (checkTerm(ans.ans1, '學生')) {
            possibleItems = [
                ['edu_1', i18n.t(`home.scenes.edu.items.edu_1`)],
                ['edu_2', i18n.t(`home.scenes.edu.items.edu_2`)]
            ]
        }


        console.log(possibleItems)
        console.log(possibleSights)
        if (possibleItems.length === 0 || possibleSights.length === 0) return this.getRandomItem()

        let item = possibleItems[Math.floor(Math.random() * possibleItems.length)];
        let sight = possibleSights[Math.floor(Math.random() * possibleSights.length)];
        console.log(item, sight)

        let recommendation = {
            scene: item[0].split('_')[0],
            title: item[1].title_main,
            item_id: item[0].split('_')[1],
            sight: sight[0],
            sight_name: sight[1].name
        };
        return recommendation
    }
}